
/**
 * Get client information for legal compliance tracking
 * Optimized version - no async IP lookup to avoid signup delays
 */
export const getClientInfo = () => {
  const userAgent = navigator.userAgent;
  
  // Remove IP address collection to avoid network delays during signup
  // IP tracking can be added later via background processes if needed
  return {
    userAgent,
    ipAddress: undefined, // Will be undefined, but that's acceptable for legal compliance
  };
};
